import './AircraftCost.scss';
import { useEffect, useState, useCallback } from 'react';
import { getAircraftCost } from '../../../../services/API/Stats';
import { prepareTable } from '../../../../utils/func';
import { AIRCRAFT_COST_STATS_HEADERS } from '../../../../utils/const';
import { Loader } from '../../../generics/Loader/Loader';
import Table from '../../../generics/Table/ReactTable';
import Bar from '../../../generics/Charts/Bar';
import RoleGuard from '../../../generics/RoleGuard/RoleGuard';
import { UserRole } from '../../../../utils/interface/user';

export const AircraftCost = () => {
  const [data, setData] = useState(null as any);
  const [selectedRows, setSelectedRows] = useState([] as any[]);
  const [loading, setLoading] = useState(true);
  const [tableKey, setTableKey] = useState(0);

  useEffect(() => {
    getAircraftCost()
      .then(res => {
          // console.log(res.data);
          setData({
          datas: prepareTable(AIRCRAFT_COST_STATS_HEADERS, res.data),
          headers: AIRCRAFT_COST_STATS_HEADERS,
        });
        setLoading(false);
        // Réinitialiser la table pour forcer la sélection de toutes les lignes
        setTableKey(prev => prev + 1);
      })
      .catch(err => console.error(err));
  }, []);

  const handleSelectedRows = useCallback((rows: any) => {
    setSelectedRows(rows.map((row: any) => row.original));
  }, []);

  return (
    <RoleGuard allowedRoles={[UserRole.CPS_ADMIN]}>
      <div id="FlightTimesStats" className="statsContainer">
        {loading ? (
          <Loader />
        ) : (
          <>
            <Table 
              key={tableKey}
              selectedRows={handleSelectedRows} 
              datas={data.datas} 
              headers={data.headers} 
              filters={false} 
              selectable={true} 
              onEdit={null} 
              initialSelectAll={true}
            />
            <div className="statsSection" id="chart">
              <h3>Aircraft Cost</h3>
              <div className="graphContainer">
                <Bar
                  legends={['Planned', 'Real']}
                  data={selectedRows}
                  keys={['plannedAircraftCost', 'burntAircraftCost']}
                  indexBy={'reg'}
                  mode={'grouped'}
                  labels={['Planned', 'Real']}
                  colors={['#03A9F4', '#016593']}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </RoleGuard>
  );
};
